import React from 'react'
import { MetricCardProps } from '../../types';
import { TrendingUp } from 'lucide-react';

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  change,
  icon,
  trend,
}) => (
  <div className="bg-white dark:bg-gray-900 rounded-lg p-6 shadow-sm border border-gray-200 dark:border-gray-700">
    <div className="flex items-start justify-between">
      <div>
        <p className="text-sm font-medium text-gray-600 dark:text-gray-300 mb-1">{title}</p>
        <h3 className=" font-bold text-gray-900 dark:text-gray-100 mb-2">{value}</h3>
        <div className="flex items-center">
          <TrendingUp
            className={`w-4 h-4 mr-1 ${
              trend === "up" ? "text-green-500 dark:text-green-400" : "text-red-500 dark:text-red-400"
            }`}
          />
          <span
            className={`text-sm font-medium ${
              trend === "up" ? "text-green-600 dark:text-green-400" : "text-red-600 dark:text-red-400"
            }`}
          >
            {change} vs last period
          </span>
        </div>
      </div>
      <div className="p-3 rounded-lg bg-gray-50 dark:bg-gray-800">{icon}</div>
    </div>
  </div>
);
